import { Role } from "@/interfaces/Role";
import { UserInterface } from "@/interfaces/UserInterface";

export class UserModel implements UserInterface {
  user_id: number;
  name: string;
  lastname: string;
  email: string;
  role: Role;
  links: string[];

  constructor(userData?: any) {
    this.user_id = userData?.user_id || 0;
    this.name = userData?.first_name || "";
    this.lastname = userData?.last_name || "";
    this.email = userData?.email || "";
    this.role = this.mapUserTypeToRole(userData?.user_type);
    this.links = userData?.links || [];
  }

  // Dodaj funkciju za mapiranje user_type iz tokena na Role enum
  private mapUserTypeToRole(userType: string): Role {
    switch (userType) {
      case "ADMIN":
        return Role.Admin;
      case "MANAGED":
        return Role.ManagedUser;
      case "STANDALONE":
        return Role.StandaloneUser;
      default:
        return Role.Guest;
    }
  }
}
